import { useContext, useState } from 'react';
import './Auth.css'
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AdminContext } from '../../Context/AdminContext';

function Auth() {

    const [existingUser, setExistingUser] = useState(true);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { login, signup, addItems, authLoading } = useContext(AdminContext);
    const requestedReturn = location.state?.returnTo;
    const returnTo = typeof requestedReturn === 'string' && requestedReturn.startsWith('/') && !requestedReturn.startsWith('//')
      ? requestedReturn
      : '/';
    const pendingCartItem = location.state?.pendingCartItem;

    const finishAuthentication = async (authenticate) => {
      await authenticate();
      let cartAdded = false;
      if (pendingCartItem) {
        try {
          await addItems(pendingCartItem);
          cartAdded = true;
          toast.success('Your selection was added to the cart.');
        } catch (error) {
          toast.error(error.message || 'You are signed in, but the item could not be added.');
        }
      }
      navigate(returnTo, { replace: true, state: cartAdded ? { openCart: true } : null });
    };

    const handleSignup = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
          await finishAuthentication(() => signup({ displayName: name, email, phone, password }));
          toast.success('Account created successfully.');
        } catch (error) {
          toast.error(error.message || 'Unable to create your account.');
        } finally {
          setIsSubmitting(false);
        }
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
          await finishAuthentication(() => login({ email, password }));
        } catch (error) {
          toast.error(error.message || 'Login failed.');
        } finally {
          setIsSubmitting(false);
        }
    };

  return (
    <div className="auth-container">
      {existingUser ? (
        <form className="auth-form" onSubmit={handleLogin}>
          <h1>Login with your email</h1>
          <div className="form-group">
            <input
              type="email"
              placeholder="Enter your email"
              required
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />
            <input
              type="password"
              placeholder="Enter your password"
              required
              onChange={(e) => setPassword(e.target.value)}
              value={password}
            />
          </div>
          <button type="submit" disabled={authLoading || isSubmitting}>{isSubmitting ? 'Signing in…' : 'Login'}</button>
          <p>
            Don&apos;t have an account?{" "}
            <button type="button" className="form-link" onClick={() => setExistingUser(false)}>
              Sign up
            </button>
          </p>
        </form>
      ) : (
        <form className="auth-form" onSubmit={handleSignup}>
          <h1 className="signup-h1">Signup with your email</h1>
          <p className="signup-p">Create your user profile here.</p>
          <div className="form-group">
            <input
              type="text"
              placeholder="Enter your name"
              required
              onChange={(e) => setName(e.target.value)}
              value={name}
            />
            <input
              type="tel"
              placeholder="Enter a phone #: 555-555-5555"
              required
              aria-label="Phone number"
              pattern="[0-9+() .-]{7,30}"
              title="Enter a valid phone number"
              onChange={(e) => setPhone(e.target.value)}
              value={phone}
            />
            <input
              type="email"
              placeholder="Enter your email"
              required
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />
            <input
              type="password"
              placeholder="Create your Password"
              required
              minLength={10}
              onChange={(e) => setPassword(e.target.value)}
              value={password}
            />
          </div>
          <button type="submit" disabled={authLoading || isSubmitting}>{isSubmitting ? 'Creating account…' : 'Signup'}</button>
          <p>
            Already have an account?{" "}
            <button type="button" className="form-link" onClick={() => setExistingUser(true)}>
              Login
            </button>
          </p>
        </form>
      )}
    </div>
  )
}

export default Auth
